import { LOCAL_NAMESPACE } from '../storageNamespace';

/**
 * Which space a git account belongs to: `_local` (signed out of Apiboo) or an
 * Apiboo account id — the same id the keychain and the on-disk account root
 * use. Accounts saved before spaces existed (07.10.2026) belong to `_local`:
 * token accounts could be added signed out, and that is the space a sign-out
 * must never wipe. Its own module so accountsStore can use it without a cycle.
 */
export const gitAccountSpace = (account) => (account && account.space) || LOCAL_NAMESPACE;
